import { render, staticRenderFns } from "./TabTenantPrice.vue?vue&type=template&id=60b47794&scoped=true"
import script from "./TabTenantPrice.vue?vue&type=script&lang=js"
export * from "./TabTenantPrice.vue?vue&type=script&lang=js"
import style0 from "./TabTenantPrice.vue?vue&type=style&index=0&id=60b47794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b47794",
  null
  
)

export default component.exports